module.exports = "<ul id=\"tooltip-values\"></ul>";